import React, { FC, useEffect, useState } from 'react';
import SignInComponent from './SignInForm';
import { metaTitle } from '../../../util/tabTitle';
import { useNavigate } from 'react-router-dom';
import { DISPLAY_HOST_NAME } from '../../../configs';
import { getTokenInLocal } from '../../../util/cacheStorage';
import AuthShell from '../AuthShell';

const SignIn: FC = () => {
  metaTitle('Sign In');
  const navigate = useNavigate();

  const [token] = useState(getTokenInLocal());

  useEffect(() => {
    if (window.location.host === DISPLAY_HOST_NAME) {
      navigate('/display-login');
    }
    if (token) {
      navigate('/');
    }
  }, []);
  return (
    <AuthShell
      title="Welcome back"
      subtitle="Sign in to manage your digital signage workspace."
    >
      <SignInComponent />
    </AuthShell>
  );
};

export default SignIn;
